import React from "react";
import { MyCheckbox } from "components";
const BankAccountCheckBox = ({ formik }) => {
  return (
    <div>
      <div className="col-sm-4 mt-5 mb-5 disabled-action type-check-box default-checkbox">
        <MyCheckbox
          name={`default_bank_account`}
          title="Default Bank Account"
          handlechange={(event) => {
            formik.setFieldValue("default_bank_account", event.target.checked);
          }}
          checked={formik.values?.default_bank_account}
          value={formik.values?.default_bank_account}
        />
      </div>
    </div>
  );
};

export default BankAccountCheckBox;
